import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
@Component({
  selector: 'app-order-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-sidebar.component.html',
  styleUrl: './order-sidebar.component.scss'
})
export class OrderSidebarComponent {
  isDropdownOpen: { [key: string]: boolean } = {};
  constructor(private authService: AuthService, private router: Router) {}
  logout() {
    this.authService
      .signOut()
      .then(() => {
        console.log('User logged out');
        this.router.navigate(['/login']); // Redirect to login page
      })
      .catch((error) => {
        console.error('Error during logout:', error);
      });
  }
  toggleDropdown(menu: string): void {
    this.isDropdownOpen[menu] = !this.isDropdownOpen[menu];
  }
}
